<div class="header-holder">
  <div class="header">
    <div>
       <button [routerLink]="['/', HOME_PATH]" matIconButton><mat-icon class="logo" svgIcon="icon"></mat-icon></button>
    </div>

    <div>
      <button matTooltip="Växla admin eller inte" (click)="toggleAdmin()" matIconButton><mat-icon>supervisor_account</mat-icon></button>
      <button matTooltip="Växla första gången man loggar in" (click)="toggleFirstTime()" matIconButton><mat-icon>accessibility_new</mat-icon></button>
      <button matTooltip="Ta bort alla project" (click)="removeAllProjects()" matIconButton><mat-icon>file_save_off</mat-icon></button>
    </div>

    <button (click)="openMenu()" matMiniFab><mat-icon>menu</mat-icon></button>

  </div>
</div>
